// extracted by mini-css-extract-plugin
module.exports = {"row":"Layout_row__KW0wG","column":"Layout_column__3Xt-n"};